import InvoicesList from './InvoicesList';

export default InvoicesList;
